import StoreItemProcessing from './StoreItemProcessing';
import _ from 'lodash';

/**********************************************************************************/

/**
 * Record descriptors are in the format:
    const project_root = {
      project: {
        project_manager: {
        },
        project_type: {
        },
        project_template: {
        },
        builds: { } // plural for collections
      }
    }
 *  */

function getAdditionalFields(filter, currentKey, additionalFieldList = {}) {
  if (filter) {
    if (filter.additionalFields) {
      additionalFieldList[StoreItemProcessing.mapToSingular(currentKey)] = filter.additionalFields;
    }
    for (let key in filter) {
      if (key && key != 'additionalFields' && key != 'excludeFields') {
        additionalFieldList = getAdditionalFields(filter[key], key, additionalFieldList);
      }
    }
  }
  return additionalFieldList;
}

function getExcludeFields(filter, currentKey, excludeFieldList = {}) {
  if (filter) {
    if (filter.excludeFields) {
      excludeFieldList[StoreItemProcessing.mapToSingular(currentKey)] = filter.excludeFields;
    }
    for (let key in filter) {
      if (key && key != 'additionalFields' && key != 'excludeFields') {
        excludeFieldList = getExcludeFields(filter[key], key, excludeFieldList);
      }
    }
  }
  return excludeFieldList;
}

function convertChildren(rootKey, parentKey, includePath, filter, includeList) {
  let childFilter = filter[parentKey];
  if (childFilter) {
    let childPath = includePath;
    if (childPath) {
      childPath += '.';
    }
    if (parentKey != rootKey) {
      childPath += parentKey;
      includeList.push(childPath);
    }
    for (let key in childFilter) {
      if (key && key != 'additionalFields' && key != 'excludeFields') {
        includeList = convertChildren(rootKey, key, childPath, childFilter, includeList);
      }
    }
  }
  return includeList;
}

function convertToFastSerializer(filter) {
  if (filter) {
    let includeList = [];
    let rootKey = Object.keys(filter)[0];
    includeList = convertChildren(rootKey, rootKey, '', filter, includeList);
    let fastFilter = { include: includeList };
    const additionalFields = getAdditionalFields(filter, rootKey);
    if (additionalFields && _.keys(additionalFields).length){
      fastFilter.additional_fields = additionalFields;
    }
    const excludeFields = getExcludeFields(filter, rootKey);
    if (excludeFields && _.keys(excludeFields).length){
      fastFilter.exclude_fields = excludeFields;
    }
    return fastFilter;
  }
}

function getEncodedForFastSerializer(filter) {
  if (filter) {
    return encodeURI(JSON.stringify(convertToFastSerializer(filter)));
  }
}

export default {
  getEncodedForFastSerializer,
};



// WEBPACK FOOTER //
// ./src/helpers/StoreFunctions/recordDescriptorProcessing.js